"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.useToken = void 0;
var _react = require("react");
const useToken = authImplementation => {
  return (0, _react.useCallback)(async () => {
    /**
     * Clients should always return null or token string.
     * It is expected that they catch any errors internally.
     * This catch is a last resort effort in case any errors are
     * missed or slip through.
     */
    try {
      const token = await authImplementation.getToken();
      return token;
    } catch (e) {
      console.error('Caught internal:', e);
      return null;
    }
  }, [authImplementation]);
};
exports.useToken = useToken;